var _filter, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 506.3 362.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "neon"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "lightblue",
    floodOpacity: 0.5,
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "glow1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 6,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "glow1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.fi0{fill:#1590CF;stroke-width:2;stroke:#000}\n\t.fi1{fill:#0069AD;stroke-width:2;stroke:#000}\n\t.b:hover{filter:url(#neon)}\n\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st fi0",
    d: "M408.5,294.6v0.3l0,0c-27.1,0-47.4-8.8-61.7-26.3c-14.3-17.4-21.1-43.1-21.1-76.8v-0.6v-16.8 c0.3-32.5,7.4-57.7,21.7-75.4c14.3-17.6,34.6-26.1,61.7-26.1h33.1l54.2-55.4h-88.8c-27.4-0.3-54.5,6.9-78.2,20.3 c-22.8,13.1-41.6,32.5-53.6,56.2c-5.7,10.8-10,22.3-13.1,34.3c-3.1-14.6-8.3-28.5-15.1-41.7c-12.3-23.7-31.1-43.1-54.2-56.2 C178.3,22,162.1,16.1,145.3,13l149.5,167.3l-141.9,159c14.3-3.4,28.1-8.8,41-16c23.1-13.1,41.7-32.5,53.7-56.2 c5.7-10.8,10-22.3,13.1-34.3c3.1,14.6,8.3,28.5,15.1,41.7c12.3,23.7,31.1,43.1,54.2,56.2c24,13.4,51.1,20.3,78.5,19.7h73.7 l-54.5-55.7L408.5,294.6L408.5,294.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st fi1",
    points: "40.9,177.2 20.7,257.8 80.5,257.8 80.3,96 20.7,96 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st fi1",
    d: "M145.3,13.1c-10-1.9-20.2-2.7-30.4-2.6H11.8v49.7l1.4,5.5h67.1h17.5h16.5c27.1,0,47.4,8.8,61.7,26.3 c14,17.4,21.1,43.1,21.1,76.8v17.7c-0.4,32.5-7.5,57.6-21.8,75.3c-14.3,17.7-34.5,26.3-61.4,26.3H93.6H80.5H13.2l-1.2,4.6v50.8 h103.3c12.7,0.1,25.3-1.3,37.5-4.3l141.9-158.8L145.3,13.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89a93e7a866eaf3f1798cd06b6cb310e.svg";
export { ForwardRef as ReactComponent };